import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { clearSearchState } from "@/state/searchSlice";
import { clearInputsExceptFixedDropdowns, clearInputsForLoadboard, setSearchType } from "@/state/searchInputSlice";
import { MarketOverview } from "@/components/home/MarketOverview";
import { useAreFeaturesUnlocked } from "@/auth/roles";

export const Homepage = () => {
    const dispatch = useDispatch();
    const userIsLocked = !useAreFeaturesUnlocked();

    useEffect(() => {
        dispatch(clearSearchState());
        if (userIsLocked) {
            dispatch(clearInputsForLoadboard());
            dispatch(setSearchType("loadboard"));
        } else {
            dispatch(clearInputsExceptFixedDropdowns());
            dispatch(setSearchType("load_rates"));
        }
    }, [userIsLocked]);

    return <MarketOverview />;
};
